import { Extension } from '@tiptap/core'

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		customExtension: {
			indent: () => ReturnType
			outdent: () => ReturnType
		}
	}
}

export const Indent = Extension.create({
	name: 'indent',

	addOptions() {
		return {
			types: ['paragraph', 'heading'],
			indentLevels: 7,
			indentStep: 24, // px per level
		}
	},

	addGlobalAttributes() {
		return [
			{
				types: this.options.types,
				attributes: {
					indent: {
						default: 0,
						renderHTML: (attributes) => {
							if (!attributes.indent) return {}
							return {
								style: `margin-left: ${attributes.indent * this.options.indentStep}px`,
							}
						},
					},
				},
			},
		]
	},

	addCommands() {
		return {
			indent:
				() =>
				({ commands, state }) => {
					const node = state.selection.$from.node()
					const indent = node.attrs.indent

					return commands.updateAttributes(node.type.name, {
						indent: indent === undefined ? 1 : Math.min(indent + 1, this.options.indentLevels),
					})
				},

			outdent:
				() =>
				({ commands, state }) => {
					const node = state.selection.$from.node()
					const indent = node.attrs.indent

					return commands.updateAttributes(node.type.name, {
						indent: Math.max((indent || 0) - 1, 0),
					})
				},
		}
	},

	addKeyboardShortcuts() {
		return {
			Tab: () => this.editor.commands.indent(),
			'Shift-Tab': () => this.editor.commands.outdent(),
		}
	},
})
